import { FC } from 'react';
// components
import FlavorComponent from 'components/main/FlavorSystem/Edit';

const Add: FC = () => <FlavorComponent />;

export default Add;
